import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { isEmpty } from 'lodash'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'RugDetailModuleContainer'

    static propTypes = {
      currentIndex: PropTypes.number.isRequired,
      currentPicture: PropTypes.string.isRequired,
      hasError: PropTypes.bool.isRequired,
      getRug: PropTypes.func.isRequired,
      nextPicture: PropTypes.bool.isRequired,
      isPending: PropTypes.bool.isRequired,
      pictureError: PropTypes.number.isRequired,
      picturePending: PropTypes.number.isRequired,
      previewExpanded: PropTypes.bool.isRequired,
      previewOpen: PropTypes.bool.isRequired,
      previousPicture: PropTypes.bool.isRequired,
      router: PropTypes.object.isRequired,
      rug: PropTypes.object.isRequired,
      setCurrentIndex: PropTypes.func.isRequired,
      setPrimary: PropTypes.func.isRequired,
      showEditReservationModal: PropTypes.func.isRequired,
      togglePreview: PropTypes.func.isRequired,
      togglePreviewExpansion: PropTypes.func.isRequired,
      uploadDesignerPicture: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
      userPermissions: PropTypes.array.isRequired,
    }

    componentDidMount() {
      const { rugId } = this.props.router.params
      const { getRug, rug } = this.props

      if (isEmpty(rug) || rugId !== rug.id) {
        getRug(rugId)
      }
    }

    render() {
      return <WrappedComponent loaderPending={this.props.isPending} {...this.props} />
    }
  }

  return Container
}
